<template>

  <TsRow appendClass="mt-5 overflow-x-auto hide-scroll-bar">
    <TsColumn v-for="items in team">
      <TsCard appendClass="min-w-[275px] shadow-none" :data-testid="props.dataTestid + '-card-' + items.id">
        <TsImage v-if="items && items.image"
                 :data-testid="props.dataTestid + '-image-' + items.id"
                 :src="items.image" :alt="items.alt" class="mx-auto  pb-3" height="100" width="100" loading="lazy"/>
        <TsDivider appendClass="m-0 border-natural-soft-white"/>
        <TsTypography :data-testid="props.dataTestid + '-name-' + items.id" appendClass=" text-center mt-3 mb-3" as="h2">{{ items.name }}</TsTypography>
        <TsTypography :data-testid="props.dataTestid + '-position-' + items.id" appendClass=" text-center  text-[#6B7280] mb-0" as="h4">{{ items.position }}</TsTypography>
        <TsTypography :data-testid="props.dataTestid + '-description-' + items.id" variant="h5" weight="medium" appendClass="text-[#6B7280] mb-0 mt-5">{{
            items.description
          }}
        </TsTypography>
      </TsCard>
    </TsColumn>
  </TsRow>
</template>



<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type TeamMember = {
  image: string;
  alt:string;
  name: string;
  position: string;
  description: string;
};

type Props = {
  team: TeamMember[];
  dataTestid: string;
}

const props = withDefaults(defineProps<Props>(), {
  team: () => [
    {
      image: '/images/team(1).png',
      name: 'Hi, I am John',
      alt: 'John',
      position: 'Marketing Executive',
      description: 'Lorem ipsum dolor sit amet consectetur. Laoreet in penatibus elementum vitae diam sed. Euismod velit lectus mauris id tristique. Turpis varius pellentesque facilisis ultrices cras ut suspendisse aliquam. Urna a nibh vitae orci sed.'
    },
    {
      image: '/images/team(2).png',
      name: 'Hi, I am Lana',
      alt: 'Lana',
      position: 'Manager',
      description: 'Lorem ipsum dolor sit amet consectetur. Laoreet in penatibus elementum vitae diam sed. Euismod velit lectus mauris id tristique. Turpis varius pellentesque facilisis ultrices cras ut suspendisse aliquam. Urna a nibh vitae orci sed.'
    },
    {
      image: '/images/team(3).png',
      name: 'Hi, I am Jack',
      alt: 'Jack',
      position: 'SEO Executive',
      description: 'Lorem ipsum dolor sit amet consectetur. Laoreet in penatibus elementum vitae diam sed. Euismod velit lectus mauris id tristique. Turpis varius pellentesque facilisis ultrices cras ut suspendisse aliquam. Urna a nibh vitae orci sed.'
    },
    {
      image: '/images/team(2).png',
      name: 'Hi, I am Lana',
      alt: 'Lana',
      position: 'Manager',
      description: 'Lorem ipsum dolor sit amet consectetur. Laoreet in penatibus elementum vitae diam sed. Euismod velit lectus mauris id tristique. Turpis varius pellentesque facilisis ultrices cras ut suspendisse aliquam. Urna a nibh vitae orci sed.'
    }
  ]
});


</script>